import PropTypes from 'prop-types';

import { CustomTypography } from 'src/components/CustomTypography';

import { useStyles } from './useStyles';

export const VariableTooltip = ({ description }) => {
  const styles = useStyles();

  if (!description) {
    return null;
  }
  return <CustomTypography className={styles.root}>{description}</CustomTypography>;
};

VariableTooltip.propTypes = {
  description: PropTypes.string,
};
VariableTooltip.defaultProps = {
  description: null,
};
